import React from "react";
import { _getBaseUrl } from "../utils/helper";

const RatingStars = ({ currentRating }) => {
  return (
    <div className="flex items-center justify-center gap-x-2">
      {Array.from({ length: 5 }, (item, i) => i + 1).map((star) => {
        return star <= currentRating ? (
          <img
            src={_getBaseUrl("src/assets/rating-star-gold.svg", true)}
            alt=""
          />
        ) : (
          <img
            src={_getBaseUrl("src/assets/rating-star-gray.svg", true)}
            alt=""
          />
        );
      })}
    </div>
  );
};

export default RatingStars;
